var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-card-image"},[_c('img',{attrs:{"src":_setup.currentSrc},on:{"error":_setup.onImageError}})])
}
var staticRenderFns = []

export { render, staticRenderFns }